import Axios from '@/api/http'
import { baseurl } from '../common.js'
/**
 * 获取官网首页配置信息
 * */
export function getcustomdesklist(query) {
  return Axios({
    method: 'post',
    url: '/out/getcustomdesklist',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取官网首页配置信息
 * */
export function getcustomdesk(query) {
  return Axios({
    method: 'post',
    url: '/out/getcustomdesk',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
* 获取明细本表详情的数据和模板
* */
export function getapprovaldetail(query) {
  return Axios({
    method: 'post',
    url: '/out/getapprovaldetail',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取明细自定义详情页的他表数据
 * */
export function getdetailapprovinglist(query) {
  return Axios({
    method: 'post',
    url: '/out/getdetailapprovinglist',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取明细自定义详情页的他表模板
 * */
export function getwebsiteapproval(query) {
  return Axios({
    method: 'post',
    url: '/out/getapproval',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取明细自定义详情页的他表模板
 * */
export function getapprovaldashboard(query) {
  return Axios({
    method: 'post',
    url: '/out/getapprovaldashboard',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取明细自定义详情页的工坊数据
 * */
export function getwebsiteapprovalreportdatalist(query) {
  return Axios({
    method: 'post',
    url: '/out/getapprovalreportdatalist',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取明细自定义详情页的工坊数据
 * */
export function getentrycode(query) {
  return Axios({
    method: 'post',
    url: '/out/getentrycode',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 设置明细组件打开新页面的暂存信息
 * */
export function setcustomdataconf(query) {
  return Axios({
    method: 'post',
    url: '/openapi/setcustomdataconf',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}
/**
 * 获取打开新页面的暂存信息
 * */
export function getcustomdataconf(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getcustomdataconf',
    data: query,
    withCredentials: false,
    baseURL: baseurl()
  })
}